const toRecord = (list: { id?: number }[]) => ((list && list.reduce)
    ? list.reduce((record, item) => ({ ...record, [item.id]: item }), {})
    : {})

export default toRecord
